import React from 'react';

interface AuthStatusCardProps {
  title: string;
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}

const AuthStatusCard: React.FC<AuthStatusCardProps> = ({
  title,
  message,
  actionLabel,
  onAction,
}) => {
  return (
    <div className="auth-status-screen">
      <div className="auth-status-card">
        <h1>{title}</h1>
        <p>{message}</p>
        {actionLabel && onAction ? (
          <button type="button" onClick={onAction}>
            {actionLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default AuthStatusCard;
